import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/CandidatesTable/component'

export const CandidatesTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
